import React from "react";
import DatasetLineChart from "components/dashboard/charts/DatasetLineChart";
import ProductTemplateTable from "components/dashboard/product-template-table/ProductTemplateTable";
import DatasetTable from "components/dashboard/dataset-table/DatasetTable";
import {Dashboard} from "./interfaces";
import IComponentTimed = Dashboard.IComponentTimed;
import FreeText from "./free-text/FreeText";
import DatasetPieChart from "components/dashboard/charts/DatasetPieChart";
import DatasetScatterChart from "components/dashboard/charts/DatasetScatterChart";
import Sankey from "components/dashboard/charts/PlotlySankey/Sankey";



export const DashboardComponentMappingWrapper = (props: { component: string, config: any , referenceTime: string}) => {
    const config = {
        ...props.config,
        referenceTime: props.referenceTime,
        reportMode: true,
    } as any & IComponentTimed;

    switch (props.component) {
        case "DatasetLineChart":
            return <DatasetLineChart {...config} />
        case "DatasetScatterChart":
            return <DatasetScatterChart {...config} />
        case "DatasetSankeyChart":
            return <Sankey {...config} />
        case "ProductTemplateTable":
            return <ProductTemplateTable {...config} />
        case "FreeText":
            return <FreeText {...config} />
        case "DatasetTable":
            return <DatasetTable {...config}/>
        case "DatasetPieChart":
            return <DatasetPieChart {...config}/>
        default:
            return <div>Invalid/Unknown component: {props.component}</div>
    }
}